"use client";
import { createContext, useContext, useMemo, useState } from "react";

const SnackbarContext = createContext();

const SnackbarProvider = (props) => {
  const { children } = props;

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "success",
  });

  const value = useMemo(() => ({ snackbar, setSnackbar }), [snackbar]);

  return (
    <SnackbarContext.Provider value={value}>
      {children}
    </SnackbarContext.Provider>
  );
};

function useSnackbarContext() {
  const context = useContext(SnackbarContext);
  if (context === undefined) {
    throw new Error("useSnackbarContext must be used within a SnackbarContext");
  }
  return context;
}

export { SnackbarContext, SnackbarProvider, useSnackbarContext };
